<ng-container *ngIf="shippingGroup$ | async as shippingGroup">
    <gen-checkout-delivery-groups [shippingGroup]="shippingGroup" [cartCode]="cartCode" [purchaseOrderNumber]="purchaseOrderNumber">
    </gen-checkout-delivery-groups>
    <gen-checkout-special-handling [shippingGroupName]="shippingGroup.shippingGroupName" [showFgAttentionMessage]="cartHasServiceParts">
    </gen-checkout-special-handling>
</ng-container>

<gen-checkout-control-btns
    [skipPaymentTypeStep]="skipPaymentTypeStep"
></gen-checkout-control-btns>